import { related_articles_page } from '../Constants/AuthorDataArticle';
import { getTitleFromUrl } from '../Constants/StaticPages';
import { revalidate_1_hour } from '../Utils/SEO/constants';
import { getEnvironmentVariables, getPublicUrl } from '../appconfig';
import { dataSlots } from '../components/ArticlePage/Content/constant';
import {
  articleDetailFetcher,
  getLatestContentUrl,
  getRecentlyAddedArticles,
} from '../datafetchers/ArticlePage';
import { categoryNavBarDataFetcher } from '../datafetchers/CategoryPage';
import { getProductCategorySitemapData } from '../datafetchers/ProductCategory';
import { getContentLanguage } from './ContentUtils';
import { getEncodedUrl, getFilteredCategoryContent } from './helper';

export const getArticleData = async (context, caller) => {
  const webUrl = context.params.articleId;
  let id = webUrl;
  if (webUrl?.includes('-')) {
    const url = webUrl.split('-');
    id = url.pop();
  }
  const data = await getLatestContentUrl('article', id);
  const urlRecognised = data?.data?.web_url;
  let complete_web_url = '/article/' + webUrl;
  if (context.locale != 'en')
    complete_web_url = '/' + context.locale + complete_web_url;

  if (urlRecognised) {
    if (complete_web_url == urlRecognised) {
      const result = checkIfWeWantDataOnBasisEnv(
        caller,
        webUrl,
        context.locale,
      );
      if (result) {
        return result;
      }

      try {
        const articleDetail = await articleDetailFetcher('article', id, false);
        articleDetail.data.banner = [];
        articleDetail.data.comments = [];
        articleDetail.data.similarTopics = [];
        articleDetail.data.videoReviews = [];
        let related_article_data = [];
        let related_article_ids = related_articles_page[id];
        if (related_article_ids) {
          for (let article_id of related_article_ids) {
            try {
              let data = await articleDetailFetcher(
                'article',
                article_id,
                false,
              );
              related_article_data.push(data.data.post);
            } catch (e) {}
          }
        }
        const selectedLanguage = getContentLanguage(articleDetail);
        const recentlyAddedArticles = await getRecentlyAddedArticles(
          {
            skip: 0,
            limit: 20,
            articleId: id,
          },
          selectedLanguage,
        );
        const categoryData = await categoryNavBarDataFetcher();
        const sitemapData = await getProductCategorySitemapData();
        const catUrls = sitemapData?.data?.map((data) => data.url);
        let footNoteCategoryUrls =
          '<h2><strong>Product Categories</strong></h2>';
        footNoteCategoryUrls += catUrls?.reduce((acc, curr) => {
          acc += `<a href=${curr}>${getTitleFromUrl(curr, true)}</a>  |  `;
          return acc;
        }, '<p>');
        footNoteCategoryUrls += '</p>';

        const formDataProps = {
          name: articleDetail?.data?.post?.content?.title,
          id: id,
        };
        const tagsList = articleDetail?.data?.post?.content?.tags;
        const isAssessmentArticle = () => {
          const containsElement = tagsList?.some((element) => {
            const present = showAssesmentOnTopics.indexOf(element) !== -1;
            if (present) {
              return true;
            }
          });
          return containsElement;
        };

        const showDiaper = () => {
          const containsElement = tagsList?.some((element) => {
            for (let i = 0; i < showdiaperBannerTags?.length; i++) {
              const present = element.includes(showdiaperBannerTags[i]);
              if (present) {
                return true;
              }
            }
          });
          return containsElement;
        };

        let modifiedHtmlString = articleDetail?.data?.post?.content?.body;
        const paragraphs =
          articleDetail?.data?.post?.content?.body.split('</p>');
        const tableRows =
          articleDetail?.data?.post?.content?.body.split('</tr>');

        if (paragraphs?.length < 5) {
          const rows = [];
          const lines = articleDetail?.data?.post?.content?.body.split('</tr>');
          if (lines?.length >= 10) {
            let inBody = false;
            lines.forEach((line) => {
              if (line.includes('<tbody>')) {
                inBody = true;
              } else if (line.includes('</tbody>')) {
                inBody = false;
              } else if (inBody && line.includes('<tr>')) {
                rows.push(line.trim() + '</tr>');
              }
            });
            let chunkSize = 5;
            const rowChunks = [];
            for (let i = 0; i < rows.length; i += chunkSize) {
              const chunk = rows.slice(i, i + chunkSize);
              rowChunks.push(chunk);
            }

            // Create tables for each chunk of rows
            const tables = rowChunks.map((chunk, index) => {
              const tableHtml =
                index === 0
                  ? `
                        <table border="1">
                        <tbody>
                        <tr>
                        <th>Name</th>
                        <th>Meaning</th>
                        </tr>
                        ${chunk.join('')}
                        </tbody>
                        </table>
                        `
                  : `
                        <table border="1">
                        <tbody>
                        ${chunk.join('')}
                        </tbody>
                        </table>
                        `;
              return tableHtml;
            });

            // The last table may have less than 8 rows, so we handle it separately
            const lastTable = tables.pop();
            const remainingRows = rowChunks.reduce(
              (total, chunk) => total + chunk.length,
              0,
            );
            if (remainingRows > 0) {
              tables.push(lastTable);
            }

            // Output the tables
            let str = '';
            tables.forEach((tableHtml, index) => {
              str += tableHtml;
              if (index < 12) {
                str += `
                                <div class="adsWrapper" id="${
                                  'articleContentAd' + index
                                }"> 
                                <p class="adStrip">Article continues below advertisment</p>
                                <ins
                            class="adsbygoogle"
                            style="display:block; text-align:center;"
                            data-ad-layout="in-article"
                            data-ad-format="fluid"
                            data-ad-client="ca-pub-5148846221422351"
                            data-ad-slot="${dataSlots[index]}"
                            id="${dataSlots[index]}"
                            ></ins>
                            </div>
                            `;
              }
            });
            const tableStartIndex =
              articleDetail?.data?.post?.content?.body.indexOf('<table ');
            const tableEndIndex =
              articleDetail?.data?.post?.content?.body.indexOf(
                '</table>',
                tableStartIndex,
              ) + '</table>'.length;

            // Check if both start and end positions were found
            if (tableStartIndex !== -1 && tableEndIndex !== -1) {
              // Remove the table content from the HTML string and insert the replacement HTML string
              const newString =
                articleDetail?.data?.post?.content?.body.substring(
                  0,
                  tableStartIndex,
                ) +
                str +
                articleDetail?.data?.post?.content?.body.substring(
                  tableEndIndex,
                );

              modifiedHtmlString = newString;
            } else {
              console.log('No table found in the HTML string.');
            }
          }
          // else
          // {
          //     modifiedHtmlString = articleDetail?.data?.post?.content?.body;
          // }
        } else {
          for (let i = 2; i < paragraphs.length; i += 5) {
            if (i < 50) {
              if (i == 2 && showDiaper()) {
                const adtag = `
                                        <div class="adsWrapper foreignAd" id=${
                                          'articleContentAd' + (i + 1) / 5
                                        }>
                                        <p class="adStrip">Article continues below advertisment</p>
                                        <ins
                                        class="adsbygoogle"
                                        style="display:block; text-align:center;"
                                        data-ad-layout="in-article"
                                        data-ad-format="fluid"
                    data-ad-client="ca-pub-5148846221422351"
                    data-ad-slot=${dataSlots[(i + 1) / 5 - 1]}
                    id=${dataSlots[(i + 1) / 5 - 1]}
                    ></ins>
                    </div>
                    `;
                paragraphs[i] += adtag;
              } else {
                const adtag = `
                                        <div class="adsWrapper" id=${
                                          'articleContentAd' + (i + 1) / 5
                                        }>
                                        <p class="adStrip">Article continues below advertisment</p>
                                        <ins
                                        class="adsbygoogle"
                                        style="display:block; text-align:center;"
                                        data-ad-layout="in-article"
                                        data-ad-format="fluid"
                    data-ad-client="ca-pub-5148846221422351"
                    data-ad-slot=${dataSlots[(i + 1) / 5 - 1]}
                    id=${dataSlots[(i + 1) / 5 - 1]}
                    ></ins>
                    </div>
                    `;
                paragraphs[i] += adtag;
              }
            }
          }

          modifiedHtmlString = paragraphs.join('</p>');
        }
        // Convert the modified HTML back to a string

        return {
          props: {
            articleDetail: articleDetail,
            articleId: id,
            webUrl: context.params.articleId,
            related_article_data: related_article_data,
            language: selectedLanguage,
            recentlyAddedArticles: recentlyAddedArticles?.data?.data,
            footNoteCategoryUrls,
            locale: context.locale,
            isExpertVerified: articleDetail?.data?.post?.content?.expertData,
            formDataProps: formDataProps,
            categoryData: getFilteredCategoryContent(categoryData?.data),
            assesmentArticle: isAssessmentArticle() && selectedLanguage == 'en',
            modifiedHtmlString: modifiedHtmlString,
          },
          revalidate: revalidate_1_hour,
        };
      } catch (error) {
        if (error?.response?.status == '404') {
          return {
            notFound: true,
            revalidate: 60,
          };
        } else {
          return {
            redirect: {
              destination: '/500',
            },
          };
        }
      }
    } else {
      const final_url = getEncodedUrl(urlRecognised);
      return {
        redirect: {
          destination: final_url,
          statusCode: 301,
        },
      };
    }
  }
  return {
    notFound: true,
  };
};

export const checkIfWeWantDataOnBasisEnv = (caller, id, locale) => {
  return;
  const isServerAndNotProductionEnv =
    caller === 'server' && getEnvironmentVariables() !== 'production';
  const isClientAndProducttionEnv =
    caller === 'client' && getEnvironmentVariables() === 'production';
  if (isServerAndNotProductionEnv || isClientAndProducttionEnv) {
    return {
      props: {
        articleId: id,
        locale: locale,
      },
    };
  }
};

export const getCustomRelatedUrls = (content) => {
  const relatedWebUrls = content?.relatedContentWebUrl;
  const varientsUrls = [];
  for (let i = 0; i < relatedWebUrls?.length; i++) {
    let replica = { ...relatedWebUrls[i] };
    if (replica['href']) {
      replica['href'] =
        getPublicUrl() +
        encodeURIComponent(replica.href)?.split('%2F').join('/');
      varientsUrls.push(replica);
    }
  }
  return varientsUrls || [];
};

export const showAssesmentOnTopics = [
  // "Pregnancy",
  'Trying to Conceive',
  'Pregnancy Complications',
  // "Secondpregnancy",
  'Pregnancybooks',
  // "Pregnancypillow",
  'Conception',
  'Pregnancytest',
  'Ovulation',
  'Fertility',
  'Infertility',
  // "Twinpregnancy",
  // "Multiplepregnancy",
  'ttc_recommended',
  // "pregnancy_recommended",
  // "pregnancy_discover",
  // "Pregnancy & Birth",
  'ttc',
  // "PregnancyJourney",
  // "PregnancyMyths",
  'ComplicationsInPregnancy',
  // "PregnancyEmotionalCare",
  // "EctopicPregnancy",
  'PregnancyTests',
  // "PregnancyBump",
  'IVFPregnancy',
  // "PregnancyBrain",
  // "PregnancyMusic",
  'ttc_home',
  'trying_to_conceive',
  'Age & Fertility',
  'PreconceptionHealth',
  'False Pregnancy',
  // "High Risk Pregnancy",
  // "Post Term Pregnancy",
  // "Pregnancy At 30",
  // "Pregnancy At 40",
  // "Late Pregnancy",
  // "Early Pregnancy",
  'Ovulation Prediction Kits',
  'Fertility Problems',
  'SecondaryFertility',
  'MaleInfertility',
  'MST_TTC',
  // "MST_Pregnancy",
  // "PregnancyDietChart",
  // "Pregnancyessentials Top Categories",
  // "MyPregnancyJourney",
  // "PositivePregnancyTestMemory",
  // "My_Pregnancy_Announcement_Contest",
  // "Selfcare During Pregnancy",
  // "Most bought during pregnancy",
  // "pregnancy basics",
  // "Pregnancy Essentials Subcategories",
  'BeforeOvulation1',
  'BeforeOvulation2',
  'BeforeOvulation3',
  'BeforeOvulation4',
  'BeforeOvulation5',
  'BeforeOvulation6',
  'BeforeOvulation7',
  'BeforeOvulation8',
  'BeforeOvulation9',
  'BeforeOvulation10',
  'BeforeOvulation11',
  'BeforeOvulation12',
  'BeforeOvulation13',
  'BeforeOvulation14',
  'BeforeOvulation15',
  'DuringOvulation1',
  'DuringOvulation2',
  'DuringOvulation3',
  'DuringOvulation4',
  'DuringOvulation5',
  'Clinic_L1_Conception_Clinic',
  // "Clinic_L1_Pregnancy_Clinic",
  'Clinic_L2_Infertility_Treatment_Consultant',
  'Clinic_L2_PCOS_Management_Plan_for_Fertility',
  // "Clinic_L2_Pregnancy_nutrition_plan",
  // "Clinic_L2_Post_pregnancy_weightloss_Plan",
  'Clinic_L2_Infertility _treatment_for_Women',
  // "Clinic_L2_Pregnancy_HCG_test",
  // "Clothing Pregnancy L-1 App",
  'Combos TTC & Pregnant - L-1 App',
  'Best Sellers TTC L-1 App',
  'Clinic_L2_TTC_Screening_Test',
  // "Pregnancy Belt",
  'Duringovulation',
  'BeforeOvulation',
  // "Pregnancy Pillow new",
  'Clinic_L2_Weight_Loss_Plan_For_Conception',
  'Clinic_L2_Fertility_Plan_for_Natural_Conception',
  // "Pregnancy Precautions",
  // "Sex During Pregnancy",
  // "Pregnancy Dos & Don'ts",
  // "Pregnancy Best Foods",
  // "Safe exercise in pregnancy",
  'Conception Myths & Facts',
  'Onboarding-Choose Freebie TTC',
  // "Super saver combos - pregnancy hairfall",
  'L1-web-Fertility',
  'L2-web-fertility-By Concern',
  'L2-web-fertility-By Type',
  'L2-web-fertility-By Ingredient',
  'L3-web-ingredient-fertility-Chamomile',
  'L3-web-concern-fertility-PCOS',
  // "Pregnancy Kit",
  'Ovulation Test Kit',
  // "L1-app- Category - Pregnancy Essentials: First Trimester",
  // "L1 Category -Pregnancy Essentials: Second Trimester",
  'fertility & sexual wellness (2)',
  'Fertility and Sexual Wellness',
  // "Pregnancy Test Kit",
  'Ovulation Test_Kit',
  'L3-web-fertility-concern-Pregnancy test kit',
  'L3-web-fertility for her-concern-fertility',
  'L3-web-ovulation test kit - concern - fertility',
  'L3-web-fertility for him-concern-fertility',
  'male fertility',
  'female fertility',
  'L3-web-shatavari-ingredient-fertility',
  'L3-web-myo-inositol-ingredient-fertility',
  'ovulation kit',
  'Ovulation_',
  'super saver combo - fertility',
  'New Brand Archi: Fertility & Sexual Wellness',
  'clinic L2: pre-conception care plan',
  // "clinic L2: pregnancy care plan",
  'Fertility Combos',
  'Ovaluna and Ovulation Test Kit',
  'L2 Category - Fertility Combo Care',
  'L2 Category - Ovulation Test Kit',
  'Freebie Ovulation Test Kit with Ovaluna',
];

export const articleIdCanonicalMapping = {
  235444: '/product-category/baby-soap',
  235500: '/product-category/baby-soap',
};

export const showdiaperBannerTags = [
  'infant',
  'baby',
  'babynames',
  'parenting',
  'toddler',
];
